import {
   Component, Input, ComponentFactoryResolver, ViewChild, ViewContainerRef,
   OnInit, OnDestroy, EventEmitter, AfterViewInit, ContentChildren, QueryList, AfterContentInit, Output
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

import { AcoesService, GridService, MessageService, NavigationService } from 'kmm-corp-api';

import { ModeloGridListaComponent } from '../modelo-grid/lista/modelo-grid.lista';
import { KeyboardShortcutsService } from 'ng-keyboard-shortcuts';
import { GridColumnComponent } from './grid-column/grid-column.component';
import { GridColumn } from '../models/grid-column.model';
import { Grid } from '../interfaces/grid';

@Component({
   selector: 'app-grid-component',
   templateUrl: './grid.component.html',
   styleUrls: ['./grid.component.scss']
})
export class GridComponent<T> implements OnInit, OnDestroy, AfterViewInit, AfterContentInit, Grid<T> {

   @ViewChild('customComponentsContainer', { static: true, read: ViewContainerRef }) customComponentsContainer: ViewContainerRef;
   @ViewChild('dxDataGrid', { static: true, read: DxDataGridComponent }) dxDataGrid: DxDataGridComponent;
   @ViewChild('popupsContainer', { static: true, read: ViewContainerRef }) popupsContainer: ViewContainerRef;
   @ViewChild('modeloGridLista', { static: true, read: ModeloGridListaComponent }) modeloGridLista: ModeloGridListaComponent;

   @ContentChildren(GridColumnComponent, { descendants: true }) templateContent: QueryList<GridColumnComponent>;

   @Input() contextName?: string = '';
   @Input() height: string;
   @Input() popup: boolean = false;
   @Input() selectionMode: string = 'none';

   /**
    * NÃ£o excluir
    */
   @Input() pageSize: number = 20;
   @Input() showPageSize = true;
   @Input() summaries: any;
   @Input() summaryItems: any;
   //

   @Output() onDataSourceReady: EventEmitter<any> = new EventEmitter();
   @Output() preparedRow: EventEmitter<any> = new EventEmitter();

   private _toolbar: any;

   dataModel: T;
   columns: GridColumn[];
   customColumns: any[];

   factory: any = [];
   componentRef: any = [];
   componentInstance: any = [];

   popupComponents: Array<any>;
   popupFactory: any = [];
   popupComponentRef: any = [];
   popupComponentInstance: any = [];

   onRefresh: Subject<any>;

   onOpenInsert: Subject<any>;
   onOpenFilter: Subject<any>;
   acoesService: AcoesService;

   refreshGrid: Subscription;
   dataSourceEvent: Subscription;

   context: any;

   stateStoringEnabled: boolean = false;
   currentGridState: any;

   constructor(
      protected _factoryResolver: ComponentFactoryResolver,
      protected _gridService: GridService,
      protected _keyboardService: KeyboardShortcutsService,
      protected _messageService: MessageService,
      protected _navigationService: NavigationService,
   ) {
      this._keyboardService.add([
         {
            key: ['ctrl + shift + s', 'cmd + shift + s'],
            command: () => this.toggleModeloPopup(true),
            preventDefault: true
         }
      ]);
   }

   ngOnInit() {
      this.context = this._gridService.gridContext[this.contextName];

      this.loadSource();

      this.refreshGrid = this._gridService.refreshGrid.subscribe((refresh) => {
         this.currentGridState = this.dxDataGrid.instance.state();

         if (refresh) {
            this.loadSource(false);
         }
      });

      this.columns = this._gridService.gridContext[this.contextName].columns;
      this.summaries = this._gridService.gridContext[this.contextName].summaries;
      this.summaryItems = this._gridService.gridContext[this.contextName].summaryItems;

      this.columns.forEach((item, index) => {
         if (!item['caption']) {
            const i = item.dataField.replace('.', '_');

            const label = this._gridService.gridContext[this.contextName].dataModel['label_' + i];

            if (label) {
               Object.assign(item, {
                  caption: label.text
               });
            }
         }
      });

      Object.assign(this.columns, this._gridService.customColumns);

      this.createCustomComponents();
   }

   ngAfterViewInit() {
   }

   ngAfterContentInit() {
   }

   getState(changeSource: boolean = true) {
      this._gridService.getModelos({ grid_ref: this.contextName, padrao: true }).subscribe(data => {
         if (changeSource) {
            if (data.length > 0) {
               this.stateStoringEnabled = false;

               const modelo = data[0];
               const state = JSON.parse(modelo.colunas);

               this.currentGridState = state;

               this.dxDataGrid.instance.state(this.currentGridState);
            } else {
               this.currentGridState = this.dxDataGrid.instance.state();

               this.stateStoringEnabled = true;

               this.onDataSourceReady.emit(data);
            }
         } else {
            this.dxDataGrid.instance.state(this.currentGridState);
         }
      });
   }

   loadSource(changeState: boolean = true) {
      if (this._gridService.gridContext[this.contextName].dataSource) {
         this.dataSourceEvent = this._gridService.gridContext[this.contextName].dataSource({})
            .subscribe(data => {
               this.dxDataGrid.instance.option('dataSource', data);

               this.getState(changeState);
            });
      }
   }

   createCustomComponents() {
      this.columns.forEach((item, templateIndex) => {
         if (item['cellTemplate']) {
            const factory = this._factoryResolver.resolveComponentFactory(item['component']);
            this.factory.push(factory);

            const componentRef = this.customComponentsContainer.createComponent(factory);
            this.componentRef.push(componentRef);

            const componentInstance = componentRef.instance;

            Object.assign(componentInstance, {
               context: this,
               cellTemplate: item['cellTemplate'],
               templateName: item['cellTemplate']
            });

            Object.assign(componentInstance, item['editorOptions']);

            this.componentInstance.push(componentInstance);
         }
      });
   }

   createPopupComponents() {
      if (this.popupComponents) {
         this.popupComponents.forEach((item, index) => {
            if (item.render) {
               this.popupFactory.push(this._factoryResolver.resolveComponentFactory(item.component));
            }
         });

         this.popupFactory.forEach((item, index) => {
            this.popupComponentRef.push(this.popupsContainer.createComponent(item));
         });

         this.popupComponentRef.forEach((item, index) => {
            this.popupComponentInstance.push(item.instance);
         });

         this.popupComponentInstance.forEach((item, index) => {
            item.context = this.popupComponents[index].context;
         });
      }
   }

   showForm() {
      this.popupComponents.forEach((item, index) => {
         if (item.form) {
            const factory = this._factoryResolver.resolveComponentFactory(item.component);
            const ref = this.popupsContainer.createComponent(factory);

            Object.assign(ref.instance, item.context);

            ref.instance['popupFormVisible'] = true;
         }
      });
   }

   isDisabled(evento: string): boolean {
      return true;
   }

   showInsert() {
      return true;
   }

   onExporting(event) {
      notify({
         message: 'O download foi iniciado',
         type: 'info',
         displayTime: 3000,
         closeOnClick: true,
         width: function () { return window.innerWidth / 1.8; }
      });
   }

   onExported(event) {
      notify({
         message: 'O download foi concluÃ­do com sucesso',
         type: 'success',
         displayTime: 3000,
         closeOnClick: true,
         width: function () { return window.innerWidth / 1.8; }
      });
   }

   onToolbarPreparing(event) {
      const toolbarItems = event.toolbarOptions.items;

      toolbarItems.forEach(function (item) {
         if (item.name === 'searchPanel') {
            item.location = 'after';
         }
      });

      const defaultItems = [
         {
            location: 'after',
            widget: 'dxButton',
            options: {
               icon: 'refresh',
               hint: 'Atualizar',
               elementAttr: {
                  id: 'atualizar'
               },
               onClick: () => this._gridService.callRefresh()
            }
         },
         {
            location: 'after',
            widget: 'dxButton',
            options: {
               icon: 'fas fa-table',
               hint: 'Modelo',
               elementAttr: {
                  id: 'modelo'
               },
               onClick: () => this.toggleModeloPopup()
            }
         }
      ];

      let items;

      if (this.toolbar) {
         items = defaultItems.concat(this.toolbar);
      } else {
         items = defaultItems;
      }

      items.forEach(item => {
         toolbarItems.push(item);
      });
   }

   toggleModeloPopup(showForm: boolean = false) {
      this.modeloGridLista.visible = true;
      this.modeloGridLista.modeloGridForm.visible = showForm;
   }

   onRowPrepared(e) {
      this.preparedRow.emit(e);
   }

   ngOnDestroy() {
      this.refreshGrid.unsubscribe();
      if (this._gridService.gridContext[this.contextName].dataSource) {
         this.dataSourceEvent.unsubscribe();
      }
   }

   @Input()
   set toolbar(toolbar: any) {
      this._toolbar = toolbar;
   }

   get toolbar(): any {
      return this._toolbar;
   }

   customizeExportData(columns, rows) {
      rows.forEach(row => {
         const rowValues = row.values;

         for (let i = 0; i < rowValues.length; i++) {
            if (typeof rowValues[i] === 'string') {
               // Eliminar tags HTML de strings
               const plainText = rowValues[i].replace(/<[^>]*>/g, '');

               rowValues[i] = plainText;
            }

         }
      });
   }

}
